import React from 'react'

const Footer = () => {
  return (
    <footer>
        <div className='footer-container'>
            <p>Sidiraos - 2023</p>
            <p>Wolverine icons , Iron man icons , Spiderman icons , Batman Icons found on iconfinder.com</p>

        </div>
    </footer>
  )
}

export default Footer